var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.hide()}}}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_vm._t("header"),_vm._v(" "),_vm._t("content"),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/common/modal.vue?vue&type=template&id=933f1eba
// module id = v1Gb
// module chunks = 0